/* unplugin-vue-components disabled */import __unplugin_components_3 from '~icons/ep/close';
import { ElIcon as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_1 from '~icons/ep/expand';
import __unplugin_components_0 from '~icons/ep/fold';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/guide.png';
const _withScopeId = n => (_pushScopeId("data-v-35d69b9f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "guide"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-center"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 接入发行引导 ")], -1));
const _hoisted_4 = {
  class: "flex-center icons"
};
const _hoisted_5 = {
  class: "step-title"
};
const _hoisted_6 = {
  class: "flex-center"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  style: {
    "color": "#B9BBD7"
  }
};
const _hoisted_9 = ["innerHTML"];
export default /*#__PURE__*/_defineComponent({
  __name: 'guide',
  emits: ['close'],
  setup(__props, {
    emit: __emit
  }) {
    const optimizedResize = function () {
      let callbacks = [];
      let running = false;
      // fired on resize event
      function resize() {
        if (!running) {
          running = true;
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(runCallbacks);
          } else {
            setTimeout(runCallbacks, 66);
          }
        }
      }
      // run the actual callbacks
      function runCallbacks() {
        callbacks.forEach(function (callback) {
          callback();
        });
        running = false;
      }
      // adds callback to loop
      function addCallback(callback) {
        if (callback) {
          callbacks.push(callback);
        }
      }
      return {
        // public method to add additional callback
        add: function (callback) {
          if (!callbacks.length) {
            window.addEventListener('resize', resize);
          }
          addCallback(callback);
        }
      };
    }();
    const steps = [{
      title: '创建游戏',
      desc: `创建游戏项目并填写相关信息`,
      icon: require('../images/create.png')
    }, {
      title: 'SDK接入',
      desc: `<div>下载适合平台的SDK；</div>
                  <div>获取游戏SDK参数；</div>
                  <div>根据接入文档及演示demo接入SDK</div>`,
      icon: require('../images/sdk.png')
    }, {
      title: '接入测试',
      desc: `运行已接入SDK的母包，进行登录和支付的功能测试`,
      icon: require('../images/test.png')
    }, {
      title: '创建渠道及配置',
      desc: `<div>创建需打包的渠道并填入相关参数；</div>
                  <div>1. 打包参数中的渠道参数配置、签名、ICON、闪屏及皮肤、插件均为客户端生效，需在出包前配置完成；</div>
                  <div>2. 渠道线上配置中的登录及支付参数、分享方式开关、商品管理均为线上服务端生效。</div>`,
      icon: require('../images/channel.png')
    }, {
      title: '渠道打包',
      desc: `通过本地打包工具生成渠道包`,
      icon: require('../images/pack.png')
    }, {
      title: '官方分包',
      desc: `国内官方安卓渠道包可通过线上进行分包并发布CDN用以发布不同的官方平台`,
      icon: require('../images/official.png')
    }, {
      title: '出包提审上架',
      desc: `国内官方安卓渠道包可通过线上进行分包并发布CDN用以发布不同的官方平台`,
      icon: require('../images/publish.png')
    }];
    const show = ref(true);
    const guideBody = ref();
    const initHeight = () => {
      const wh = window.innerHeight - 150;
      if (guideBody.value) {
        guideBody.value.style.height = (wh > 930 ? 930 : wh) + 'px';
      }
    };
    const emits = __emit;
    const handleClick = type => {
      initHeight();
      if (type === 'toggle') {
        show.value = !show.value;
      } else if (type === 'close') {
        emits('close');
      }
    };
    onMounted(() => {
      initHeight();
      optimizedResize.add(() => {
        initHeight();
      });
    });
    return (_ctx, _cache) => {
      const _component_i_ep_fold = __unplugin_components_0;
      const _component_i_ep_expand = __unplugin_components_1;
      const _component_el_icon = __unplugin_components_2;
      const _component_i_ep_close = __unplugin_components_3;
      const _directive_drag = _resolveDirective("drag");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, {
        onClick: _cache[0] || (_cache[0] = $event => handleClick('toggle'))
      }, {
        default: _withCtx(() => [_unref(show) ? (_openBlock(), _createBlock(_component_i_ep_fold, {
          key: 0
        })) : (_openBlock(), _createBlock(_component_i_ep_expand, {
          key: 1
        }))]),
        _: 1
      }), _createVNode(_component_el_icon, {
        onClick: _cache[1] || (_cache[1] = $event => handleClick('close')),
        class: "marginL10"
      }, {
        default: _withCtx(() => [_createVNode(_component_i_ep_close)]),
        _: 1
      })])]), _withDirectives(_createElementVNode("div", {
        class: "guide-body",
        ref_key: "guideBody",
        ref: guideBody
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (item, index) => {
        return _createElementVNode("div", {
          class: "step-item",
          key: item.title
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
          src: item.icon,
          alt: ""
        }, null, 8, _hoisted_7), _createElementVNode("span", null, _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_8, "0" + _toDisplayString(index + 1), 1)]), _createElementVNode("div", {
          class: "step-desc",
          innerHTML: item.desc
        }, null, 8, _hoisted_9)]);
      }), 64))], 512), [[_vShow, _unref(show)]])])), [[_directive_drag, [50, 300]]]);
    };
  }
});